module.exports = __webpack_public_path__ + "assets/img/23_137.ad999152.jpg";